import { CrmAdapter, CrmId } from "./emailThumbnail.types";

const fieldPath = "[A-Za-z_][A-Za-z0-9_]*(?:\\.[A-Za-z_][A-Za-z0-9_]*)*";
const marketoDisplayName =
  "[A-Za-z_][A-Za-z0-9_-]*(?: [A-Za-z0-9_][A-Za-z0-9_.-]*)*";

const createAdapter = (
  id: CrmId,
  label: string,
  renderField: (field: string) => string,
  tokenPattern: RegExp,
  capabilities: CrmAdapter["capabilities"]
): CrmAdapter => ({
  id,
  label,
  renderField,
  isValidToken: (token) => tokenPattern.test(token),
  capabilities,
});

export const CRM_ADAPTERS: Record<CrmId, CrmAdapter> = {
  any: createAdapter(
    "any",
    "Any CRM",
    (field) => `{{${field}}}`,
    new RegExp(`^\\{\\{${fieldPath}\\}\\}$`),
    { nativeLength: false, precomputedBucket: false }
  ),
  hubspot: createAdapter(
    "hubspot",
    "HubSpot",
    (field) => `{{${field}}}`,
    new RegExp(`^\\{\\{${fieldPath}\\}\\}$`),
    { nativeLength: false, precomputedBucket: false }
  ),
  salesforce: createAdapter(
    "salesforce",
    "Salesforce / Pardot",
    (field) => `{{{${field}}}}`,
    new RegExp(
      `^(?:\\{\\{\\{${fieldPath}\\}\\}\\}|\\{\\{Recipient\\.${fieldPath}\\}\\})$`
    ),
    { nativeLength: false, precomputedBucket: false }
  ),
  sfmc: createAdapter(
    "sfmc",
    "Salesforce Marketing Cloud",
    (field) => `%%${field}%%`,
    new RegExp(`^%%${fieldPath}%%$`),
    { nativeLength: true, precomputedBucket: false }
  ),
  optimove: createAdapter(
    "optimove",
    "Optimove",
    (field) => `@${field}@`,
    new RegExp(`^@${fieldPath}@$`),
    { nativeLength: false, precomputedBucket: false }
  ),
  mailchimp: createAdapter(
    "mailchimp",
    "Mailchimp",
    (field) => `*|${field.replace(/\./g, "_").toUpperCase()}|*`,
    /^\*\|[A-Z_][A-Z0-9_]*\|\*$/,
    { nativeLength: false, precomputedBucket: true }
  ),
  marketo: createAdapter(
    "marketo",
    "Marketo",
    (field) => `{{lead.${field}}}`,
    new RegExp(`^\\{\\{lead\\.(?:${fieldPath}|${marketoDisplayName})\\}\\}$`),
    { nativeLength: false, precomputedBucket: false }
  ),
  salesloft: createAdapter(
    "salesloft",
    "Salesloft",
    (field) => `{{${field}}}`,
    new RegExp(`^\\{\\{${fieldPath}\\}\\}$`),
    { nativeLength: false, precomputedBucket: false }
  ),
};
